import { TEquipmentMaintenanceBlankType } from '@/pages/Equipment/equipment.types'
import { IOption } from '@/types/global'

const options: IOption<TEquipmentMaintenanceBlankType>[] = [
  { title: 'Плановое', value: 'PLANNED' },
  { title: 'Внеплановое', value: 'UNPLANNED' },
]

const maintenanceTypeDropdownConstants = { options }

export default maintenanceTypeDropdownConstants
